import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { BankAccountForSelectFragment } from 'generated/resources/graphql'

import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import { useForm } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { BankAccountSelector } from 'modules/banking/components/BankAccountSelector'

import { PaymentFormValues } from './useForm'

export interface NewBulkPaymentFormProps {
  form: ReturnType<typeof useForm<PaymentFormValues>>
}

export const NewBulkPaymentForm = ({ form }: NewBulkPaymentFormProps) => {
  const [selectedBankAccount, setSelectedBankAccount] =
    React.useState<BankAccountForSelectFragment | null>(null)

  const handleSelectBankAccount = (bankAccount: BankAccountForSelectFragment | null) => {
    form.setFieldValue('bankAccountId', bankAccount?.id)
    setSelectedBankAccount(bankAccount)
  }

  return (
    <Box gap="s16">
      <Box gap="s6">
        <TextField
          label={i18n.t('banking.bulk_payment.forms.fields.name.label')}
          placeholder={i18n.t('banking.bulk_payment.forms.fields.name.placeholder')}
          value={form.values.label}
          onChange={(value) => form.setFieldValue('label', value)}
          error={form.errors.label}
          mandatory
        />
        <Text size="100" weight="medium" color="grey600">
          {i18n.t('banking.bulk_payment.forms.fields.name.alert')}
        </Text>
      </Box>
      <BankAccountSelector
        mandatory={!selectedBankAccount}
        emptyLabel={i18n.t('banking.bulk_payment.forms.fields.account.placeholder')}
        width="s400"
        onSelect={handleSelectBankAccount}
        value={selectedBankAccount}
        label={i18n.t('banking.bulk_payment.forms.fields.account.label')}
        accountNumberTypes={['iban']}
        providerService="sepa_payment_management"
        currency="EUR"
      />
      <TextArea
        label={i18n.t('banking.bulk_payment.forms.fields.opt_description.label')}
        placeholder={i18n.t('banking.bulk_payment.forms.fields.opt_description.placeholder')}
        value={form.values.description}
        onChange={(value) => form.setFieldValue('description', value)}
      />
    </Box>
  )
}
